import type { TripStatus } from "../trips/types";

const statusClass: Record<TripStatus, string> = {
  Draft: "orbit-tone-slate",
  Planned: "orbit-tone-blue",
  Dispatched: "orbit-tone-blue",
  "In Transit": "orbit-tone-blue",
  Delivered: "orbit-tone-amber",
  Billed: "orbit-tone-blue",
  "Partially Settled": "orbit-tone-amber",
  Settled: "orbit-tone-emerald",
  Cancelled: "orbit-tone-rose",
};

const pulseStatuses: TripStatus[] = ["Cancelled", "Partially Settled", "Delivered"];

type StatusBadgeProps = {
  status: TripStatus;
};

export function StatusBadge({ status }: StatusBadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold ${statusClass[status]}`}
    >
      {pulseStatuses.includes(status) ? (
        <span className="h-1.5 w-1.5 rounded-full bg-current opacity-80 animate-pulse" />
      ) : null}
      {status}
    </span>
  );
}
